import { render } from "./Select.vue?vue&type=template&id=f0221eb4&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=f0221eb4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0221eb4"

export default script